import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import styles from "./googlePay3DSecureModal.module.scss";

const GooglePay3DSecureModal: FunctionComponent<{ isVisible: boolean; url?: string }> = observer(({ isVisible, url }) => {
  const rootRef = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onHide = () => {};

  // As allowpaymentrequest is not recognized, we need to use the spread operator instead.
  const iframeProps = {
    allowpaymentrequest: "true",
  };

  return (
    <div ref={rootRef}>
      <Modal dialogClassName={styles.dialogIframeWrapper} show={isVisible && url !== undefined} onHide={onHide} centered>
        <Modal.Body className={styles.dialogIframe}>
          <iframe allow="payment" {...iframeProps} src={url}></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
});

export default GooglePay3DSecureModal;
